import { FapBaseModel } from '../../base/fap-base-model';


export class NoteTypeModel extends FapBaseModel {
    public static fields: Array<string> = [
        'id',
        'name',
        'name_t',
        'color',
        'form_type'
    ];

    public static requiredFields: Array<string> = [
        'id',
    ];

    public static extendedFields: {} = {
    };

    public id: number;
    public name: string;
    public nameT: string;
    public color: string;
    public formType: number;
}
